/** First line = title; following lines = body (checklist items with prose). */

export function splitItemText(text: string): { title: string; body: string } {
  const normalized = text.replace(/\r\n/g, '\n');
  const idx = normalized.indexOf('\n');
  if (idx === -1) {
    return { title: normalized, body: '' };
  }
  return {
    title: normalized.slice(0, idx),
    body: normalized.slice(idx + 1),
  };
}

export function joinItemText(title: string, body: string): string {
  const t = title.replace(/\r\n/g, '\n').replace(/\n/g, ' ').trimEnd();
  const b = body.replace(/\r\n/g, '\n').trim();
  if (!b) return t;
  return `${t}\n${b}`;
}

export function itemTextHasBody(text: string): boolean {
  return text.replace(/\r\n/g, '\n').includes('\n');
}
